import React from 'react';

export const HrBotContext = React.createContext({});
